import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props {
    aiRepository: AIRepository;
}

@injectable()
export class GetAIChatParsedFilesUseCase {
    _aiRepository: AIRepository;

    constructor(_: props) {
        this._aiRepository = _.aiRepository;
    }

    public call = async (chatId: string, body?: any): Promise<any> => {
        return await this._aiRepository.getAIChatParsedFiles(chatId, body);
    }
}

export const GetAIChatParsedFilesUseCaseName = "GetAIChatParsedFilesUseCaseName";
